
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz'
import Skill from '@/components/Skill'
import SkillModel from '@/models/Skill'

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h2" components={components} props={{"id":"skill"}}>{`Skill`}</MDXTag>
<Playground __position={0} __code={'<Skill model={SkillModel.create({ name: \'Survival\' })} />\n<Skill\n  model={SkillModel.create({\n    mastery: 4,\n    name: \'Fighting Style: Sword & Board\',\n    theory: 2,\n  })}\n/>'} __scope={{props: this ? this.props : props,Skill,SkillModel}}>
  <Skill model={SkillModel.create({ name: 'Survival' })} />
  <Skill model={SkillModel.create({
    mastery: 4,
    name: 'Fighting Style: Sword & Board',
    theory: 2,
  })} />
</Playground>
           </MDXTag>
  }
}
  